module.exports = __webpack_public_path__ + "media/Video 97.a435e587.mp4";